// assets/xgen-bootstrap.js — single entry for search + collection PLP grids
import { initializeXgenSearch, initializeXgenCollection } from 'xgen-main';

function bootXgenGrid() {
  if (document.body.classList.contains('template-search-body')) {
    initializeXgenSearch();
  } else if (document.body.classList.contains('template-collection-body')) {
    initializeXgenCollection();
  }
}

document.addEventListener('xgen-ready', bootXgenGrid);
if (window.xgenClient) {
  bootXgenGrid();
}
